import { render, staticRenderFns } from "./TemplateWrapper.vue?vue&type=template&id=28ce7cf4&"
import script from "./TemplateWrapper.vue?vue&type=script&lang=js&"
export * from "./TemplateWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports